import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBzw_jhrPdLsUsxAFwal1OtB-1-Q3P9YkY",
  authDomain: "nn-fit.firebaseapp.com",
  projectId: "nn-fit",
  storageBucket: "nn-fit.firebasestorage.app",

  messagingSenderId: "508935349889",
  appId: "1:508935349889:web:361f59fe100c164c348f80",
  measurementId: "G-36NX0QX6PK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
// old functions
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export default app;
export const storage = getStorage(app);
